<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer006">
<div class="centerfull">
<img alt="" src="image/graykeys.gif"/>
</div>
<p class="frontmatter_list-head">Praise for <br/><em>Jane Doe and the Cradle of All Worlds</em></p>
<p class="frontmatter_list">“Immediately exciting and inventive, this is a thrilling story set in a universe made up of multiple worlds . . . Jane is a wonderful character—warm, brave and funny—and the secondary characters are equally charming . . . this action-packed adventure thriller will appeal to a wide range of readers . . . and could well be our next <span class="frontmatter_CMS-ital">Nevermoor</span>.”</p>
<p class="frontmatter_list-attribute">—Angela Crocombe, <span class="frontmatter_CMS-ital">Books+Publishing</span></p>
<p class="frontmatter_list">“A fantastic fast-paced exciting adventure set in a magical labyrinth of a manor with rooms that shift, booby traps and a classic bad guy who will stop at nothing to get what he wants. I highly recommend this book for kids 11+.”</p>
<p class="frontmatter_list-attribute">—Dani Solomon, Readings Kids</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// x9781541541771.vue?1677f342